import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setMfproductFilterCriteria } from 'store/slice/ManufSlice';

export default function MfproductFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.manufslice.mfproductDashboard);
        
    const {categoryList} = useSelector((state)=>state.manufslice);
    
const updateTitleCriteria = (title) =>{
        dispatch(setMfproductFilterCriteria(
            {
                ...filterCriteria,
                title:title
        }))
    }
const updateCodeCriteria = (code) =>{
        dispatch(setMfproductFilterCriteria(
            {
                ...filterCriteria,
                code:code
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Title"
                            name="title"
                            value={filterCriteria.title}
                            onChange={(e)=>updateTitleCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Code"
                            name="code"
                            value={filterCriteria.code}
                            onChange={(e)=>updateCodeCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}